'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _redux = require('redux');

var _courier = require('../actions/courier');

var INITIAL_STATE = {
    isFetching: false,
    didInvalidate: false,
    items: []
};
var couriers = function couriers() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments[1];

    switch (action.type) {
        case _courier.INVALIDATE_COURIERS:
            return _extends({}, state, {
                didInvalidate: true
            });
        case _courier.REQUEST_COURIERS:
            return _extends({}, state, {
                isFetching: true,
                didInvalidate: false
            });
        case _courier.RECEIVE_COURIERS:
            return _extends({}, state, {
                isFetching: false,
                didInvalidate: false,
                items: action.couriers
            });
        case _courier.FAILURE_COURIERS:
            return _extends({}, state, {
                isFetching: false,
                error: action.error
            });
        default:
            return state;
    }
};

var courierReducer = (0, _redux.combineReducers)({
    couriers: couriers
});

exports.default = courierReducer;


//////////////////
// WEBPACK FOOTER
// ./src/js/reducers/courier.js
// module id = 905
// module chunks = 0